import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_BLOCK } from "./apiRoutes";

interface UseGetProps {
  communityId: string;
  zoneId?: string | number;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyBlockDropdown = async (
  communityId: string,
  zoneId?: string | number
) => {
  const params = zoneId ? `?zoneId=${zoneId}` : "";
  return await axiosAuth.get(`${PROPERTY_BLOCK(communityId)}/dropdown${params}`);
};

const useGetPropertyBlockDropdown = ({
  communityId,
  zoneId,
  queryParams,
}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-block-dropdown", communityId, zoneId],
    queryFn: () => getPropertyBlockDropdown(communityId, zoneId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyBlockDropdown;
